import { makeCreateLimitOperation } from './make-create-limit-operation';
import { LimitScope, LimitsGroupFormValue, LimitType } from './types';

export const getCreateLimitOperation = (
  offerId: string,
  values: LimitsGroupFormValue,
  limitScope: LimitScope,
  limitType: LimitType,
) => {
  const configuration = values[limitScope];

  if (!configuration) {
    return null;
  }

  if (configuration.isEnabled && typeof configuration.limit === 'number') {
    return makeCreateLimitOperation(
      offerId,
      {
        limit: configuration.limit,
        timePeriod: 'timePeriod' in configuration ? configuration.timePeriod : undefined,
      },
      limitType,
      limitScope,
    );
  }

  return null;
};
